import React, { Component } from "reactn";
import PropTypes from "prop-types";
import { Div, P, Span, Button } from "glamorous";
import Touch from "./Touch";
import Desktop from "./Desktop";
import styles from "../../../styles";
import bottleImgs from "../../../imgs/bottles";
import data from "../../../data";
import {touchsupport, promiseImage, track} from "../../../misc/utils";
import { labelDimensions } from "../../../misc/constants";
import { ExperienceConsumer } from "../../../providers/ExperienceContext";


const LabelPreview = touchsupport() ? Touch : Desktop;

class PreviewLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: window.innerWidth
    };
  }

  componentDidMount() {
    this.renderLabel();
    window.addEventListener("resize", this.viewportUpdate.bind(this));
  }

  render() {
    const {
      productId,
      handleAddToBasket,
      price,
      currencyId,
    } = this.props;

    return (
      <Div className="container container--generic">
        <LabelPreview
          bottleImage={this.global.selectedBottleImageUrl ? this.global.selectedBottleImageUrl : bottleImgs.bases[productId]}
          method={this.props.method}
        >
          <canvas
            width="1320"
            height="1800"
            style={
              this.state.height > 800
                ? styles.label.labelCanvas
                : styles.label.labelCanvasSmall
            }
            ref={canvas => (this.theCanvas = canvas)}
          />
        </LabelPreview>

        {price && (
          <P css={styles.label.total}>
            {data.copy("totalPrice")}
            <Span css={styles.label.price}>
              {data.currencies[currencyId]}
              {price}
            </Span>
          </P>
        )}

        <Div className="clearfix" />

        {this.context.isInStore && (
          <Button onClick={() => {
            track.event('button', 'click', 'preview_print_label');
            this.props.setArea("PrintLabel");
          }} css={styles.ctas.preview}>
            {data.copy("printYourLabel")}
          </Button>
        )}

        {!this.context.isInStore && (
          <Button onClick={() => handleAddToBasket()} css={styles.ctas.preview}>
            {data.copy("addToBasketBtn")}
          </Button>
        )}
        
        <Button onClick={() => {
          track.event('button', 'click', 'preview_return_to_start');
          this.props.setArea("Landing")
        }} css={styles.ctas.outlineMaxWidth}>
          {data.copy("returnToStart")}
        </Button>
        
      </Div>
    );
  }

  async renderLabel() {
    const ctx = this.theCanvas.getContext("2d");
    const image = await promiseImage(this.props.label.renderedLabel);
    ctx.setTransform(1.425, 0, 0, 1.425, -300, 750);

    let x = 500;
    let y = 230;

    ctx.translate( x, y );
    ctx.rotate(-Math.tan(19.5 * Math.PI / 180));
    ctx.translate( -x, -y );

    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, image.width, image.height + 30);
    ctx.drawImage(image, 0, 15, labelDimensions.width, labelDimensions.height);
  }

  viewportUpdate() {
    this.setState({ height: window.innerHeight });
  }
}

PreviewLabel.propTypes = {
  images: PropTypes.object.isRequired,
  productId: PropTypes.string.isRequired,
  handleAddToBasket: PropTypes.func.isRequired,
  price: PropTypes.string,
  currencyId: PropTypes.string
};

PreviewLabel.contextType = ExperienceConsumer;
export default PreviewLabel;



// WEBPACK FOOTER //
// ./src/components/areas/PreviewLabel/index.js